import { render, staticRenderFns } from "./MailgunMailDriver.vue?vue&type=template&id=13208de6&"
import script from "./MailgunMailDriver.vue?vue&type=script&lang=js&"
export * from "./MailgunMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13208de6')) {
      api.createRecord('13208de6', component.options)
    } else {
      api.reload('13208de6', component.options)
    }
    module.hot.accept("./MailgunMailDriver.vue?vue&type=template&id=13208de6&", function () {
      api.rerender('13208de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mail-driver/MailgunMailDriver.vue"
export default component.exports